"use strict";
/**
 *
 *
 *
 *
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var forEach_1 = __importDefault(require("lodash/forEach"));
var isObject_1 = __importDefault(require("lodash/isObject"));
function euc(s) {
    return encodeURIComponent(s).replace(/%2C/g, ',');
}
function _serializeBoolean(keyName, value, structure) {
    return value ? [{ key: encodeURIComponent(keyName), value: '1' }] : [];
}
function _serializeNumber(keyName, value, structure) {
    return [{ key: encodeURIComponent(keyName), value: encodeURIComponent(value) }];
}
function _serializeString(keyName, value, structure) {
    return [{ key: encodeURIComponent(keyName), value: encodeURIComponent(value) }];
}
function _serializeArray(keyName, values, structure) {
    if (typeof values === 'string')
        values = values.split(',');
    if (values == null)
        return [];
    if (!values.length)
        return [];
    // currently we support arrays of only strings or numbers
    return [{ key: keyName, value: values.map(encodeURIComponent).join(',') }];
}
function _serializeHash(keyName, value, structure) {
    var result = [];
    for (var subkey in structure)
        if (structure.hasOwnProperty(subkey) && value.hasOwnProperty(subkey)) {
            var arr = _serialize(subkey, value[subkey], structure[subkey]);
            if (keyName) {
                arr = arr.map(function (item) { return ({
                    key: encodeURIComponent(keyName) + '.' + item.key,
                    value: item.value
                }); });
            }
            result = result.concat(arr);
        }
    return result;
}
function _serialize(keyName, value, structure) {
    if (value == null)
        return [];
    else if (structure === Boolean)
        return _serializeBoolean(keyName, value, structure);
    else if (structure === Number)
        return _serializeNumber(keyName, value, structure);
    else if (structure === String)
        return _serializeString(keyName, value, structure);
    else if (Array.isArray(structure))
        return _serializeArray(keyName, value, structure);
    else if (isObject_1["default"](structure))
        return _serializeHash(keyName, value, structure);
    return [];
}
//
// deserialize: build hash from string
//
function _deserializeBoolean(str, structure) {
    return str === '1' || str === 'true';
}
function _deserializeString(str, structure) {
    return str || null;
}
function _deserializeNumber(str, structure) {
    var value = parseFloat(str);
    return !isNaN(value) ? value : null;
}
function _deserializeArray(str, type) {
    return str
        .split(',')
        .map(function (val) { return _deserializeValue(val, type[0]); })
        .filter(function (v) { return v != null; });
}
function _deserializeValue(str, type) {
    if (type === Boolean)
        return _deserializeBoolean(str, type);
    else if (type === Number)
        return _deserializeNumber(str, type);
    else if (type === String)
        return _deserializeString(str, type);
    else if (Array.isArray(type))
        return _deserializeArray(str, type);
    // type cannot be Object so ignore it (ex: no 'geo=...' in url, only 'geo.lat=...', 'geo.lng=...')
    return null;
}
function filterHash(h, fn) {
    var r = {};
    forEach_1["default"](h, function (v, k) {
        if (fn(k, v))
            r[k] = v;
    });
    return r;
}
function mapHashKeys(h, fn) {
    var r = {};
    forEach_1["default"](h, function (v, k) { return (r[fn(k, v)] = v); });
    return r;
}
// isObject([]) === true; isObject(Number) === true
function isHash(h) {
    return isObject_1["default"](h) && !Array.isArray(h) && typeof h !== 'function';
}
function _deserialize(structure, q) {
    var result = {};
    // all unstructured
    forEach_1["default"](q, function (value, key) {
        if (!(key.split('.')[0] in structure)) {
            result[key] = value;
        }
    });
    // all structured
    forEach_1["default"](structure, function (type, sKey) {
        if (isHash(type)) {
            var fh = filterHash(q, function (k, v) { return k.indexOf(sKey + '.') === 0; });
            result[sKey] = _deserialize(type, mapHashKeys(fh, function (k, v) { return k.substr(sKey.length + 1); }));
        }
        else {
            result[sKey] = _deserializeValue(q[sKey] || '', type);
        }
    });
    return result;
}
var UrlSerializable = /** @class */ (function () {
    function UrlSerializable(structure) {
        this._structure = structure;
    }
    // return string: "key1=value1&key2=value2&key3=v3,v4,v5&..."
    // TODO: Keep right order!
    UrlSerializable.prototype.serializeSearch = function (urlObject) {
        var urlItems = _serialize('', urlObject, this._structure);
        // add unregistered keys
        for (var key in urlObject) {
            if (urlObject.hasOwnProperty(key) && !(key in this._structure)) {
                var value = urlObject[key];
                if (value === undefined || value === null) {
                    //
                }
                else if (typeof value === 'string' || typeof value === 'number') {
                    urlItems.push({ key: euc(key), value: euc(urlObject[key]) });
                }
                else if (typeof value === 'boolean') {
                    // TODO
                }
                else {
                    // TODO: array, hash
                }
            }
        }
        var result = urlItems
            .map(function (item) { return item.key + '=' + item.value; })
            .join('&');
        return result;
    };
    // input: string "key1=value1&key2=value2&key3=v3,v4,v5&..."
    // output: typed object
    UrlSerializable.prototype.deserializeSearch = function (urlString) {
        var params = (urlString || '')
            .split('&')
            .reduce(function (h, q) {
            var _a;
            return q.match(/^([^=]*)(?:=(.*))?$/)
                ? __assign(__assign({}, h), (_a = {}, _a[decodeURIComponent(RegExp.$1)] = decodeURIComponent(RegExp.$2 || ''), _a)) : h;
        }, {});
        var result = _deserialize(this._structure, params);
        return result;
    };
    return UrlSerializable;
}());
exports["default"] = UrlSerializable;
